module.exports = __webpack_public_path__ + "static/media/logoGood.a2487659.svg";